import React, { useState, useEffect } from 'react'
import Home from './components/Home'
import { makeStyles, fade } from "@material-ui/core/styles";
import Navbars from './components/NavBar/Navbars';
import StoredApi from './utils/StoredAPI'
import Loader from './components/Loader/Loader';
import axios from "./utils/Axios";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom"; // Importa los componentes necesarios de react-router-dom

const useStyles = makeStyles(theme => ({
    root: {
        height: '100vh',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        display: 'flex',
        flexDirection: "column",
    },
}))

const App = () => {
    const classes = useStyles();
    //const trelloUser = JSON.parse(localStorage.getItem('DBUSER'));
    //const [user, setUser] = useState(trelloUser)
    const [loader, setLoader] = useState(false);
    
    const changeBG = (url) => {
        setLoader(true);
        setTimeout(() => {
            setLoader(false)
        }, 3000)
    }

    return (
        <div>
           <StoredApi.Provider value={{ changeBG }}>
                <Router>
                    {loader && <Loader />}
                    <div className={classes.root}
                        style={{
                            backgroundColor: `#181820`
                        }}
                    >
                        <Navbars />
                        <Routes>
                            <Route path="/" element={<Home/>} />
                        </Routes>
                    </div>
                </Router>
            </StoredApi.Provider>
        </div>
    )
}

export default App
